import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { AutocompleteListItem } from './AutocompleteListItem';
export var AutocompleteDefaultItem = forwardRef(function (_a, ref) {
    var _b = _a.highlighted, highlighted = _b === void 0 ? false : _b, attributes = _a.attributes, _c = _a.selected, selected = _c === void 0 ? false : _c, item = _a.item;
    return (React.createElement(AutocompleteListItem, __assign({ ref: ref }, attributes, { highlighted: highlighted, selected: selected, label: item.label, subLabel: item.subLabel })));
});
//# sourceMappingURL=AutocompleteDefaultItem.js.map